import { createShader, colorUniform } from "./ShaderBase.js";

export const nebulaShader = createShader({
  customizable: [
    { uniform: "uColor1", label: "Background", default: "#1a0033" },
    { uniform: "uColor2", label: "Primary", default: "#661a99" },
    { uniform: "uColor3", label: "Secondary", default: "#334dcc" },
    { uniform: "uColor4", label: "Accent", default: "#cc3380" },
  ],

  uniforms: {
    uPixelSize: { value: 12.0 },
    uScale: { value: 0.4 },
    uSpeed: { value: 0.15 },
    uColor1: colorUniform("#1a0033"),
    uColor2: colorUniform("#661a99"),
    uColor3: colorUniform("#334dcc"),
    uColor4: colorUniform("#cc3380"),
    uColor5: colorUniform("#1a99cc"),
    uBrightness: { value: 1.2 },
  },

  fragmentUniforms: `
    uniform vec3 uColor1;
    uniform vec3 uColor2;
    uniform vec3 uColor3;
    uniform vec3 uColor4;
    uniform vec3 uColor5;
    uniform float uBrightness;
  `,

  fragmentBody: `
    // Two layers of noise for nebula effect
    float n1 = snoise(animatedPos);
    float n2 = snoise(animatedPos * 2.0 + vec3(50.0));

    // Normalize noise values to 0-1 range
    n1 = (n1 + 1.0) * 0.5;
    n2 = (n2 + 1.0) * 0.5;

    // Mix colors based on noise layers
    vec3 color = uColor1;
    color = mix(color, uColor2, smoothstep(0.3, 0.7, n1) * 0.8);
    color = mix(color, uColor3, smoothstep(0.4, 0.8, n2) * 0.6);

    // Combined noise for additional variation
    float combined = n1 * n2;
    color = mix(color, uColor4, smoothstep(0.3, 0.6, combined) * 0.5);

    // Bright highlights
    float highlight = smoothstep(0.5, 0.7, combined);
    color = mix(color, uColor5, highlight * 0.6);

    // Apply brightness
    color *= uBrightness;

    gl_FragColor = vec4(color, 1.0);
  `,
});
